import PriceList from '@/views/pages/PriceList.vue'

const router = {
    path: '/price-list',
    name: 'Price List',
    component: PriceList,
    meta: {
        title: 'Price List'
    }
  };

export default router
